import { sharedCommon } from "@shared/locales/en/US";

const common = {
  ...sharedCommon,
  title: "Fullscript's Dispensing Catalog",
  metaDescription:
    "Prescribe virtually or shop from over 300 professional quality supplement brands for in-office dispensing all in one place.",
  NpNowFS:
    "naturalpartners.com is now fullscript.com. Create a free account to get all the benefits of Natural Partners plus more.",
  Dismiss: "Dismiss",
  LearnMore: "Learn more",
} as const;

export { common };
